import ApplicationStepper, {
  ApplicationStep,
} from '@/app/pages/family_application/ApplicationStepper'
import { ProviderPaymentStep, ProviderPaymentStepType } from '@/app/pages/providers/provider.constants'
import { BackIcon } from '@/common/icons/general.tsx'
import { cn } from '@/common/utilities.ts'
import { AppRoutePaths } from '@/routing/route_paths'
import React from 'react'
import { useTranslation } from 'react-i18next'


type ProviderApplicationStep = ApplicationStep & {
  field?: string
  step: ProviderPaymentStepType
}

const ProviderPaySteps: ProviderApplicationStep[] = [
  {
    name: 'provider',
    code: 'selectProvider',
    title_translation_key: 'select_provider',
    location: AppRoutePaths.providers.pay_provider.select_provider,
    field: 'selectedProvider',
    step: ProviderPaymentStep.SELECT_PROVIDER

  },
  {
    name: 'add_details',
    code: 'addDetails',
    title_translation_key: 'add_details',
    location: AppRoutePaths.providers.pay_provider.add_details,
    field: 'paymentAmount',
    step: ProviderPaymentStep.ADD_DETAILS
  },
  {
    name: 'upload_documents',
    code: 'uploadDocuments',
    title_translation_key: 'upload_documents',
    location: AppRoutePaths.providers.pay_provider.upload_documents,
    field: 'documents',
    step: ProviderPaymentStep.UPLOAD_DOCUMENTS
  },
  {
    name: 'choose_purse',
    code: 'choosePurses',
    title_translation_key: 'choose_purse',
    location: AppRoutePaths.providers.pay_provider.choose_purses,
    field: 'purses',
    step: ProviderPaymentStep.CHOOSE_PURSES
  },
  {
    name: 'expense_type',
    code: 'expenseType',
    title_translation_key: 'expense_type',
    location: AppRoutePaths.providers.pay_provider.expense_type,
    field: 'categories',
    step: ProviderPaymentStep.SELECT_EXPENSE_TYPE
  },
  {
    name: "allocate_expenses",
    code: "allocateExpenses",
    title_translation_key: "allocate_expenses",
    location: AppRoutePaths.providers.pay_provider.expense_allocation,
    field: "allocatedExpenses",
    step: ProviderPaymentStep.EXPENSE_ALLOCATION
  },
  {
    name: 'review_and_submit',
    code: 'review',
    title_translation_key: 'review_and_submit',
    location: AppRoutePaths.providers.pay_provider.review_and_submit,
    field: 'submitted',
    step: ProviderPaymentStep.REVIEW

  },
]

type Props = {
  onBack: () => void
  children: React.ReactNode
  currentStep: ProviderPaymentStepType
}
export const PayProviderLayout = (props: Props) => {
  const { onBack, children, currentStep} = props
  const { t: translate } = useTranslation()

    // Find the current step index in our stepper array
    const currentStepIndex = ProviderPaySteps.findIndex(
      step => step.step === currentStep
  )


  // Get all completed step codes
  const completedSteps = ProviderPaySteps
      .filter((_, index) => index < currentStepIndex)
    .map(step => step.code)


      return (
    <>
      <div
        className={cn(
          'flex-grow flex flex-col'
          // isWizardRoute && 'max-w-3xl w-full'
        )}
      >
        {currentStepIndex != undefined && (
          <div className="flex items-center mb-4 lg:mb-8">
            <button
              type="button"
              onClick={onBack}
              aria-label={translate('back')}
            >
              <BackIcon className="w-6 h-6" />
            </button>
            <ApplicationStepper
              completeSteps={completedSteps}
              currentStepIndex={currentStepIndex}
              steps={ProviderPaySteps}
              className={cn('grow flex justify-center')}
            />
            <div></div>
          </div>
        )}

        <div className={cn('flex-grow flex flex-col max-w-xl w-full mx-auto')}>
          {children}
        </div>
      </div>
    </>
  )
}
